import { FC } from 'react';
import { Switch, Redirect } from 'react-router-dom';
import PruRoute from 'src/app/common/components/PruRoute';
import ParamsProvider from 'src/app/common/components/ParamsProvider';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { COMMISSION_TOOL_BASE_PATH, MASTER_DATA_SETTING_PATH } from '../../constants';
import { masterDataSettingFilterKeys } from './list/master-data-setting-listing-page.hook';
import { MasterDataSettingListingPage } from './list/master-data-setting-listing-page.screen';
import MasterDataSettingDetailPage from './form/master-data-setting-detail-page';

export const masterDataSettingPath = `${COMMISSION_TOOL_BASE_PATH}${MASTER_DATA_SETTING_PATH}`;

const MasterDataSettingRoutes: FC = () => {
  return (
    <Switch>
      <Redirect exact from={masterDataSettingPath} to={`${masterDataSettingPath}/list`} />
      <PruRoute
        exact
        path={`${masterDataSettingPath}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={masterDataSettingFilterKeys}>
            <MasterDataSettingListingPage />
          </ParamsProvider>
        )}
      />
      {/* <PruRoute exact path={`${masterDataSettingPath}/create`} component={MasterDataSettingDetailPage} /> */}
      <PruRoute exact path={`${masterDataSettingPath}/edit/:id`} component={MasterDataSettingDetailPage} />
      <PruRoute exact path={`${masterDataSettingPath}/view/:id`} component={MasterDataSettingDetailPage} />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default MasterDataSettingRoutes;
